<template>
  <div class="record-card">
    <div class="record-detail">
      <div class="left-block">
        <div class="avatar-wrap">
          <img class="avatar" :src="avatar" alt="" />
        </div>
        <div class="name-wrap">
          <div class="name">
            <img
              v-if="row.userIdentity === 1 && $route.query.activityType * 1 !== 5"
              class="tag"
              :src="require('@/assets/reward/tag-old-friend.png')"
              alt=""
            />
            <img
              v-if="row.userIdentity === 2"
              class="tag"
              :src="require('@/assets/reward/tag-extra-reward.png')"
              alt=""
            />
            <span>{{ `${row.userIdentity === 2 ? row.remark || '' : row.nickname || ''}` }}</span>
            <span
              class="award-amount"
              v-if="row.awardAmount > 0 && queryType === 3 && $route.query.activityType * 1 === 5"
            >
              <img :src="require('@/assets/reward/red-pocket.png')" width="12px" alt="" />
              <i>+{{ row.awardAmount }}</i>
            </span>
          </div>
          <p class="time">{{ timeDesc }}</p>
        </div>
      </div>
      <template v-if="queryType === 3 || queryType === 2">
        <div class="right-block" v-if="row.operateButton">
          <div class="place-order" @click="onClickButton">{{ row.operateButton.name }}</div>
          <img v-if="row.inviteSoonExpire" :src="require('@/assets/reward/invalid-tag.png')" alt="" class="invalid" />
        </div>
      </template>
      <template v-else>
        <div class="award-amount">{{ `+${row.awardAmount || 0}` }}</div>
      </template>
    </div>
    <div class="description" v-if="row.description">{{ `失效原因：${row.description || ' '}` }}</div>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
    queryType: {
      type: String,
      default: '3' // 3-在路上;0-待发放；1-已发放；2-已失效
    }
  },
  data() {
    return {
      src: require('@/assets/avatar.png')
    };
  },
  mounted() {
    document.querySelector('.container-body-main').scrollTop = 1;
  },
  computed: {
    avatar() {
      let avatar;
      if (this.row.userIdentity === 2) {
        avatar = require('@/assets/reward/extra-reward-icon.png');
      } else {
        avatar = this.row.picture || require('@/assets/reward/default-avatar.png');
      }
      return avatar;
    },
    timeDesc() {
      let timeDesc = '';
      switch (this.queryType) {
        case 0:
          // 待发放
          timeDesc = `${this.row.payTime || ''} ${this.row.awardReason || ''}`;
          break;
        case 1:
          // 已发放
          timeDesc = `${this.row.receiveTime || ''} ${this.row.awardReason || ''}`;
          break;
        case 2:
          // 已失效
          timeDesc = `${this.row.invalidTime || ''} ${this.row.awardReason || ''}`;
          break;
        case 3:
          // 在路上
          timeDesc = `${this.row.inviteTime || ''} 邀请成功`;
          break;
        default:
          break;
      }
      return timeDesc;
    }
  },
  methods: {
    onClickButton() {
      this.$bus.$emit('openShareDialog');
    }
  }
};
</script>

<style scoped lang="less">
.record-card {
  padding: 12px;
  background-color: #fff;
  .record-detail {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    .left-block {
      display: flex;
      align-items: center;
      .avatar-wrap {
        width: 32px;
        height: 32px;
        border-radius: 32px;
        overflow: hidden;
        .avatar {
          width: 100%;
          height: 100%;
        }
      }

      .name-wrap {
        margin-left: 8px;

        .name {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #595959;
          display: flex;
          align-items: center;
          .tag {
            height: 12px;
            margin-right: 4px;
          }
          .award-amount {
            height: 12px;
            font-size: 0;
            font-weight: 500;
            color: #ff4e47;
            line-height: 12px;
            margin-left: 2px;

            img {
              vertical-align: middle;
            }
            i {
              font-size: 12px;
              vertical-align: middle;
              font-style: normal;
            }
          }
        }

        .time {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #8c8c8c;
        }
      }
    }

    .right-block {
      position: relative;

      .place-order {
        width: 80px;
        height: 24px;
        background: #f65425;
        border-radius: 12px;
        text-align: center;
        color: #fff;
        line-height: 24px;
        font-size: 12px;
      }

      .invalid {
        position: absolute;
        top: -10px;
        right: 0;
        width: 44px;
        height: 13px;
      }
    }
    .award-amount {
      color: #262626;
      font-size: 16px;
    }
  }
  .description {
    margin-top: 8px;
    padding: 5px 12px;
    background-color: #f5f5f5;
    line-height: 18px;
    border-radius: 8px;
    color: #8c8c8c;
    font-size: 12px;
  }
}
</style>
